import '../styles/BillingPeriodToggle.css';

export type BillingPeriod = 'daily' | 'monthly' | 'yearly';

interface BillingPeriodToggleProps {
  selected: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
}

const BILLING_PERIODS: { value: BillingPeriod; label: string; savings?: string }[] = [
  { value: 'daily', label: 'Daily' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly', savings: 'Save 16%' },
];

export default function BillingPeriodToggle({
  selected,
  onChange,
}: BillingPeriodToggleProps) {
  return (
    <div className="billing-period-toggle">
      {BILLING_PERIODS.map(({ value, label, savings }) => (
        <button
          key={value}
          type="button"
          className={`billing-period-option ${selected === value ? 'active' : ''}`}
          onClick={() => onChange(value)}
        >
          {label}
          {savings && <span className="billing-savings-badge">{savings}</span>}
        </button>
      ))}
    </div>
  );
}
